import { render, staticRenderFns } from "./NoticeItem.vue?vue&type=template&id=2f3d763f&scoped=true&lang=pug&"
import script from "./NoticeItem.vue?vue&type=script&lang=ts&"
export * from "./NoticeItem.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeItem.vue?vue&type=style&index=0&id=2f3d763f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d763f",
  null
  
)

export default component.exports